import React from 'react';
/* Inline brand SVG marks rendered on white "card" chips, matching the reference design. */
function VisaMark() {
  return <svg viewBox="0 0 48 16" className="h-3 md:h-4" role="img" aria-label="Visa" data-id="element-191">
      <text x="0" y="13" fontFamily="Arial, sans-serif" fontWeight="700" fontStyle="italic" fontSize="15" fill="#1A1F71" data-id="element-192">
        VISA
      </text>
    </svg>;
}
function MastercardMark() {
  return <svg viewBox="0 0 40 24" className="h-4 md:h-5" role="img" aria-label="Mastercard" data-id="element-193">
      <circle cx="15" cy="12" r="10" fill="#EB001B" data-id="element-194" />
      <circle cx="25" cy="12" r="10" fill="#F79E1B" data-id="element-195" />
      <path d="M20 4.2a9.98 9.98 0 0 1 0 15.6 9.98 9.98 0 0 1 0-15.6z" fill="#FF5F00" data-id="element-196" />
    </svg>;
}
function AmexMark() {
  return <svg viewBox="0 0 50 18" className="h-3 md:h-4" role="img" aria-label="American Express" data-id="element-197">
      <rect width="50" height="18" rx="3" fill="#1F72CF" data-id="element-198" />
      <text x="25" y="13" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="9" fill="#FFFFFF" data-id="element-199">
        AMEX
      </text>
    </svg>;
}
function ApplePayMark() {
  return <svg viewBox="0 0 50 22" className="h-4 md:h-5" role="img" aria-label="Apple Pay" data-id="element-200">
      <path d="M9.5 6.1c-.5.6-1.3 1.1-2.1 1-.1-.8.3-1.7.8-2.2.5-.6 1.4-1 2.1-1.1.1.9-.3 1.7-.8 2.3zm.8 1.3c-1.2-.1-2.2.7-2.7.7-.6 0-1.4-.6-2.3-.6-1.2 0-2.3.7-2.9 1.8-1.2 2.1-.3 5.3.9 7 .6.8 1.3 1.8 2.2 1.7.9 0 1.2-.6 2.3-.6 1.1 0 1.4.6 2.3.5.9 0 1.6-.8 2.2-1.7.7-1 1-1.9 1-2-.1 0-1.9-.7-1.9-2.8 0-1.7 1.4-2.5 1.5-2.6-.8-1.2-2.1-1.3-2.6-1.4z" fill="#000000" data-id="element-201" />
      <text x="18" y="15" fontFamily="Arial, sans-serif" fontWeight="600" fontSize="11" fill="#000000" data-id="element-202">
        Pay
      </text>
    </svg>;
}
function GPayMark() {
  return <svg viewBox="0 0 56 22" className="h-4 md:h-5" role="img" aria-label="Google Pay" data-id="element-203">
      <text x="0" y="15" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="13" data-id="element-204">
        <tspan fill="#4285F4" data-id="element-205">G</tspan>
        <tspan fill="#5F6368" data-id="element-206"> Pay</tspan>
      </text>
    </svg>;
}
const methods = [{
  key: 'visa',
  Mark: VisaMark
}, {
  key: 'mastercard',
  Mark: MastercardMark
}, {
  key: 'amex',
  Mark: AmexMark
}, {
  key: 'applepay',
  Mark: ApplePayMark
}, {
  key: 'gpay',
  Mark: GPayMark
}];
export function PaymentMethods({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex flex-nowrap items-center justify-center gap-1.5 md:gap-2 ${className}`} data-id="element-207">
      {methods.map(({
      key,
      Mark
    }) => <div key={key} className="flex items-center justify-center bg-white rounded-md shadow-md px-1.5 py-1 md:px-2.5 md:py-1.5 h-7 md:h-9" data-id="element-208">
          <Mark data-id="element-209" />
        </div>)}
    </div>;
}